export const landingPageColumns = [
  { key: 'scenario_name', header: 'Scenario', type: 'notADate' },
  { key: 'modified_by_name', header: 'Owner', type: 'notADate' },
  { key: 'refresh_date', header: 'Last Refresh Date', type: 'date' },
  { key: 'modified_date', header: 'Last Modified Date', type: 'date' },
  { key: 'status', header: 'Status', type: 'notADate' }
]
